module.exports = __webpack_public_path__ + "img/alipay.a566de01.png";